module.exports = __webpack_public_path__ + "img/ic-guide-card.b723ed27.svg";